import { useTranslation } from "react-i18next";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import styled from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { Spacer, VDBText } from "@components/atoms";
import currency from "currency.js";
import { useUserCurrency } from "../../../hooks/getCurrency";
import { Diamond } from "@src/types/DiamondDetail";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { isMeleeItem } from "@utils/product/productValidators";

type ReviewPageCardProps = {
  type?: "stone" | "setting" | "matchingStone";
  itemDetail?: Diamond;
};

const PriceCardContainer = ({ type, itemDetail }: ReviewPageCardProps) => {
  const { t } = useTranslation();
  const { theme, typography } = useScreenOptionsHooks();
  const userInfo = useUserInfo();
  const userCurrency = useUserCurrency();
  return (
    <Overlay>
      <VDBText type={typography["Body-R"]} color={theme["core-06"]}>
        {type === "matchingStone"
          ? t("reviewPage.matchingStone.price.text")
          : type === "stone"
          ? t("reviewPage.stone.price.text")
          : t("reviewPage.setting.price.text")}
      </VDBText>
      <Spacer size={SpaceType.Extra} />
      <VDBText type={typography["H1-B"]} color={theme["core-05"]}>
        {currency(itemDetail?.total_sales_price, {
          symbol: userCurrency,
          precision:
            isMeleeItem(itemDetail) ||
            (!userInfo?.roundUpPrices() && type === "stone")
              ? 2
              : 0,
        }).format()}
      </VDBText>
    </Overlay>
  );
};

export default PriceCardContainer;

const Overlay = styled.View<{ type?: string }>`
  background-color: ${({ theme }) => theme["core-01"]};
  border-bottom-left-radius: ${SpaceType.Basic}px;
  border-bottom-right-radius: ${SpaceType.Basic}px;
  padding: ${SpaceType.Double}px;
  flex-direction: row;
  align-items: center;
`;
